<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <router-view class="router-content-box"></router-view>
    </transition>
  </div>
</template>

<script>

export default {
  name: 'app',
  data() {
    return {

    };
  },
  methods: {

  },
  mounted() {},
};
</script>
<style lang="scss">
  @include init-base;
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    position: relative;
    min-height: 100%;
    a {
      text-decoration: none;
    }
  }
  .router-content-box {
    min-height: calc(100vh - 270px);
  }
  .fade-enter {
    opacity: 0;
  }

  .fade-leave {
    opacity: 1;
  }

  .fade-enter-active {
    transition: opacity .5s;
  }

  .fade-leave-active {
    opacity: 0;
    transition: opacity .5s;
  }

  @keyframes active {
    from {
      height: 0;
    }
    to {
      height: 3px;
    }
  }
</style>
